import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const createRequest = async (token, data) => {
    const response = await axios.post(`${API_URL}/verification/request`, data, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

const getPendingRequests = async (token) => {
    const response = await axios.get(`${API_URL}/verification/pending`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

const approveRequest = async (token, id) => {
    const response = await axios.post(`${API_URL}/verification/${id}/approve`, {}, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

const rejectRequest = async (token, id, reason) => {
    const response = await axios.post(`${API_URL}/verification/${id}/reject`, { reason }, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

const getRejectedRequests = async (token) => {
    const response = await axios.get(`${API_URL}/verification/rejected`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

const resetCooldown = async (token, id) => {
    const response = await axios.post(`${API_URL}/verification/${id}/reset`, {}, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

const verificationService = {
    createRequest,
    getPendingRequests,
    approveRequest,
    rejectRequest,
    getRejectedRequests,
    resetCooldown
};

export default verificationService;
